/**
 * Calendário da unidade: os dias SEM expediente (feriados, recessos, pontos
 * facultativos). Segunda a sexta é o padrão; o que está aqui sai da conta de
 * dias úteis da Produção, das Solicitações e da Capacidade da Fábrica.
 *
 * Cada função recebe `request` (do useAuth) como 1º argumento e devolve o
 * JSON da resposta. `silentError`: quem chama mostra a mensagem do backend
 * (AsyncButton ou aviso na tela); sem isso sairiam dois avisos iguais. O erro
 * lançado traz o `detalhe` do backend em `err.message` e o código em
 * `err.status` (buildError do AuthContext).
 */
const PREFIXO = "/api/calendario/dias-nao-uteis";

/** Tipos aceitos pelo backend (`calendario.models.DiaNaoUtil.TIPOS`). */
export const TIPOS_DIA_NAO_UTIL = Object.freeze([
  { valor: "feriado_nacional", rotulo: "Feriado nacional" },
  { valor: "feriado_local", rotulo: "Feriado local" },
  { valor: "recesso", rotulo: "Recesso" },
  { valor: "ponto_facultativo", rotulo: "Ponto facultativo" },
]);

function comConsulta(caminho, filtros = {}) {
  const consulta = new URLSearchParams();
  Object.entries(filtros).forEach(([campo, valor]) => {
    if (valor !== undefined && valor !== null && valor !== "") consulta.set(campo, String(valor));
  });
  const texto = consulta.toString();
  return texto ? `${caminho}?${texto}` : caminho;
}

function escrever(request, metodo, caminho, corpo) {
  return request(`${PREFIXO}${caminho}`, {
    method: metodo,
    body: JSON.stringify(corpo ?? {}),
    silentError: true,
  });
}

const id = (valor) => encodeURIComponent(String(valor));

/**
 * `{dias: [DIA], anos_com_registro: [2025, ...], pode_editar}`.
 * Sem `de`/`ate` o backend devolve o ano corrente; o intervalo máximo é de
 * 800 dias.
 */
export function listarDiasNaoUteis(request, { de, ate } = {}) {
  return request(comConsulta(PREFIXO, { de, ate }), { silentError: true });
}

/** `{data, tipo, descricao}` → DIA. 409 quando a data já está cadastrada. */
export function criarDiaNaoUtil(request, { data, tipo, descricao }) {
  return escrever(request, "POST", "", { data, tipo, descricao });
}

/**
 * Um dia por dia de semana (seg a sex) de [de, ate] que ainda não exista.
 * `{criados: [DIA], ignorados: ["AAAA-MM-DD"]}`. Máximo de 62 dias.
 */
export function criarIntervalo(request, { de, ate, tipo, descricao }) {
  return escrever(request, "POST", "/intervalo", { de, ate, tipo, descricao });
}

/** Só `tipo` e `descricao` mudam; para trocar a data, remova e crie outro. */
export function atualizarDiaNaoUtil(request, diaId, { tipo, descricao }) {
  const corpo = {};
  if (tipo !== undefined) corpo.tipo = tipo;
  if (descricao !== undefined) corpo.descricao = descricao;
  return escrever(request, "PATCH", `/${id(diaId)}`, corpo);
}

export function removerDiaNaoUtil(request, diaId) {
  return request(`${PREFIXO}/${id(diaId)}`, { method: "DELETE", silentError: true });
}

/** Cria os feriados nacionais do ano que faltam: `{criados: [DIA]}`. */
export function semearNacionais(request, ano) {
  return escrever(request, "POST", "/semear-nacionais", { ano: Number(ano) });
}
